export default __webpack_public_path__ + "static/products-bg-image-77a39983fe4d2371f680d404c37b619c.jpg";